import React from "react";

import "./record-count.css";
import { testIDs } from "../../../end-to-end-tests/constants/testIDs";

const RecordCount = React.memo(props => {
    const selected = props.selectedCount !== 0;

    const counterText = selected ? (
        <div id="selected-record-count" className="margin-bottom-xs">
            <span className="clear" />
            <span className="left no-wrap">{`${props.selectedCount} selected`}</span>
            <span className="right no-wrap">
                {props.recordCount} {props.recordName}
            </span>
        </div>
    ) : (
        <>
            <div id="record-count" className="margin-bottom-xs text-right">
                {props.recordCount} {props.recordName}
            </div>
            <span className="clear" />
        </>
    );

    return (
        <div className="" data-testid={testIDs.shared.recordCount}>
            {counterText}
        </div>
    );
});

export default RecordCount;
